import React from 'react';
import SectionTitle from './SectionTitle';
import SectionSubTitle from './SectionSubTitle';
import SectionSubContainer from './SectionSubContainer';

export default ({ shipment }) => (
  <>
    <SectionTitle bubble="checkmark">
      &nbsp;
    </SectionTitle>
    <span className="pt-2">
      <SectionTitle bubble="checkmark" hidden={true}>
        {!shipment ? 'Order' : shipment.shipment_direction === 'delivery' ? 'Order' : 'Return'} received
      </SectionTitle>
      <SectionSubContainer>
        <SectionSubTitle>{shipment?.received_at}</SectionSubTitle>
      </SectionSubContainer>
    </span>
  </>
);
